import IdaqExportModel from "../../models/DataDelivery/IdaqExportModel";
import BaseStore from "../BaseStore";

export default class IdaqExportStore extends BaseStore {
  constructor(transportLayer) {
    super(IdaqExportModel, transportLayer);
  }


}


// WEBPACK FOOTER //
// ./src/stores/DataDelivery/IdaqExportStore.js